import type { MessagesResponse, TestInfoResponse } from '@sensor/shared'

/**
 * En desarrollo Vite hace proxy de /api hacia la API, y en producción la API
 * sirve este mismo bundle. En los dos casos es mismo origen: rutas relativas.
 */
async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!response.ok) throw new Error(`${url} respondió ${response.status}`)
  return (await response.json()) as T
}

export function fetchInfo(): Promise<TestInfoResponse> {
  return getJson<TestInfoResponse>('/api/test/info')
}

export function fetchMessages(since = 0, limit = 200): Promise<MessagesResponse> {
  return getJson<MessagesResponse>(`/api/test/messages?since=${since}&limit=${limit}`)
}

export async function clearMessages(): Promise<void> {
  const response = await fetch('/api/test/messages', { method: 'DELETE' })
  if (!response.ok) throw new Error(`No se pudo limpiar: ${response.status}`)
}
